var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProhibit2Line = function SvgProhibit2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.088 6.733-9.355 9.355a6.667 6.667 0 0 1 9.355-9.355M7.912 17.266l9.355-9.354a6.667 6.667 0 0 1-9.355 9.355ZM12 3.666a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.666Z"
  })));
};
export default SvgProhibit2Line;